import React from 'react'
import { ReactComponent as ZocksLogo } from '../../../assets/ZocksLogo.svg'

export const CrossClientQueryLoadingState = () => {
  return (
    <div className='d-flex zocks-gap-0.75 align-items-center'>
      <div className='d-flex align-items-center justify-content-center bg-black zocks-border-0.25 cross-client-loader-logo'>
        <ZocksLogo width={12} height={12} />
      </div>
      <div className='paragraph-medium shimmering-loader-text'>Breaking down your question into search criteria…</div>
    </div>
  )
}
